/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PhysicianContact } from './PhysicianContact';
import {
    PhysicianContactFromJSON,
    PhysicianContactFromJSONTyped,
    PhysicianContactToJSON,
} from './PhysicianContact';

/**
 * 
 * @export
 * @interface ConsultantHistory
 */
export interface ConsultantHistory {
    /**
     * 
     * @type {number}
     * @memberof ConsultantHistory
     */
    date: number;
    /**
     * 
     * @type {string}
     * @memberof ConsultantHistory
     */
    author_role?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsultantHistory
     */
    author_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsultantHistory
     */
    action: string;
    /**
     * 
     * @type {PhysicianContact}
     * @memberof ConsultantHistory
     */
    value: PhysicianContact;
}

/**
 * Check if a given object implements the ConsultantHistory interface.
 */
export function instanceOfConsultantHistory(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "action" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function ConsultantHistoryFromJSON(json: any): ConsultantHistory {
    return ConsultantHistoryFromJSONTyped(json, false);
}

export function ConsultantHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConsultantHistory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': json['date'],
        'author_role': !exists(json, 'author_role') ? undefined : json['author_role'],
        'author_id': !exists(json, 'author_id') ? undefined : json['author_id'],
        'action': json['action'],
        'value': PhysicianContactFromJSON(json['value']),
    };
}

export function ConsultantHistoryToJSON(value?: ConsultantHistory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': value.date,
        'author_role': value.author_role,
        'author_id': value.author_id,
        'action': value.action,
        'value': PhysicianContactToJSON(value.value),
    };
}

